<template>
  <div :class="['ep-radio-list',{'active':active}]" @click="seleted">
    <slot></slot>
  </div>
</template>

<script>
  import unit from '../../../lib/unit'
  export default {
    name: 'ep-radio-list',
    data() {
      return {
        active: false,
        curcolor: 'red'
      }
    },
    props: {
      label: {
        type: String,
        default: '',
      }
    },
    computed: {
      value() {
        return this.$parent.value
      }
    },
    watch: {
      value() {
        this.isSeleted()
      }
    },
    created() {
      this.$on('change', (val) => {
        if (this.label != val) {
          this.active = false
        }
      })
    },
    mounted() {
      this.isSeleted()
    },
    mixins: [unit],
    methods: {
      isSeleted() {
        if(this.value!=''&&this.value == this.label) {
          this.active = true
        }else {
        	this.active = false
        }
      },
      seleted() {
        this.dispatch('ep-radio', 'change', this.label)
        this.active = true
      }
    }
  }

</script>

<style scoped>
  .ep-radio-list {
    display: inline-block;
    cursor: pointer;
    box-sizing: border-box;
    padding: 0 10px;
    height: 100%;
    width: auto;
  }

  .ep-radio-list:hover {
    color: #00c0ef;
  }

  .active {
    color: #00c0ef;
  }
</style>


// WEBPACK FOOTER //
// radio_list.vue?3bf8583b